export default {
	idsExternoAnexoFlowbee: [],
}
